<template>
	<div class="box box_mm">
		<div class="box_main">
			<div class="search_box">
				<div class="search_item">
					<span style="width: 0.6rem;">名称：</span>
					<el-input v-model="searchinput" placeholder="请输入名称" style="width: 2rem;"></el-input>
				</div>
				<div class="search_item">
					<el-button type="primary" @click="search">搜索</el-button>
				</div>
			</div>
			<div class="box_cont">
				<div class="btn_list">
				</div>
				<div style="height: 76vh;box-sizing: border-box;">
					<MyTable ref="zjlist" :tableData="tableData" :tableHeader="tableHeader" :showbm="true"
						:czwidth="150" @getdata="gettable">
						<template slot="btns" slot-scope="{ scope }">
							<el-button @click="showdetail(scope.row)" type="success" size="mini">详情</el-button>
							<el-button v-if="scope.row.txtype==1&&scope.row.time_status==2" @click="editerow(scope.row)" type="primary" size="mini">填写</el-button>
						</template>
					</MyTable>
				</div>
			</div>
		</div>
		
		<mydetail ref="mydetail"></mydetail>
	</div>
</template>

<script>
	import mydetail from '../component/detail.vue';
	export default {
		components:{
			mydetail
		},
		data() {
			return {
				searchinput: '',
				tableHeader: [{
						prop: 'id',
						name: '序',
						width: '50'
					},
					{
						prop: 'name',
						name: '调查表名称',
						width: ''
					},
					{
						prop: 'time_status',
						name: '问卷状态',
						type: 'wenjuan_type',
						width: '130'
					},
					{
						prop: 'txtype',
						name: '是否填写',
						type: 'txtype',
						width: '130'
					},
					{
						prop: 'kstime',
						name: '开始时间',
						width: '180'
					},
					{
						prop: 'jstime',
						name: '结束时间',
						width: '180'
					},
					{
						prop: 'user_name',
						name: '创建人',
						width: '150'
					},
					{
						prop: 'addtime',
						name: '创建时间',
						width: '180'
					}
				],
				tableData: []
			}
		},
		mounted() {
			this.gettable()
		},
		methods: {
			editerow(row){
				this.$post({
					url: '/api/questionnaire/indextm',
					params: {
						questionnaire_id:row.questionnaire_id
					}
				}).then((res) => {
					res.list.forEach((item)=>{
						item.da = ''
						if(item.type==3){
							item.da = []
						}
					})
					row.timu_list = res.list
					
					Object.keys(row).forEach(key => {
					    this.$set(this.$refs.mydetail.detail, key, row[key]);
					});
					this.$refs.mydetail.islook = false
					this.$refs.mydetail.questionnaire_id = row.questionnaire_id
					this.$refs.mydetail.dialogVisible = true
				})
			},
			showdetail(row){
				this.$post({
					url: row.txtype==2?'/api/questionnaire/indexgrta':'/api/questionnaire/indextm',
					params: {
						questionnaire_id:row.questionnaire_id
					}
				}).then((res) => {
					if(row.txtype==2){
						res.list.forEach((item)=>{
							if(item.type==3){
								item.da = item.da.split(',')
							}
						})
					}else{
						res.list.forEach((item)=>{
							item.da = ''
							if(item.type==3){
								item.da = []
							}
							item.xx.forEach((item2)=>{
								if(item2.hasInput){
									item2.input_value = ''
								}
							})
						})
					}
					
					row.timu_list = res.list
					
					Object.keys(row).forEach(key => {
					    this.$set(this.$refs.mydetail.detail, key, row[key]);
					});
					this.$refs.mydetail.dialogVisible = true
				})
				
				
			},
			deleterow(row){
				this.$confirm('请确认是否删除该调查表?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$post({
						url: '/api/questionnaire/del',
						params: {
							ids:row.id
						}
					}).then((res) => {
						this.$message.success('删除成功');
						this.gettable()
					})
				})
			},
			search() {
				this.$refs.zjlist.inputpage = 1
				this.gettable()
			},
			gettable() {
				this.$post({
					url: '/api/questionnaire/appindex',
					params: {
						name: this.searchinput,
						p: this.$refs.zjlist.inputpage,
						size: this.$refs.zjlist.pagesize
					}
				}).then((res) => {
					const currentTime = new Date();
					
					res.list.forEach((item) => {
						const kstime = new Date(item.kstime);
						const jstime = new Date(item.jstime);
						if (currentTime < kstime) {
							item.time_status = 1; // 未开始
						} else if (currentTime >= kstime && currentTime <= jstime) {
							item.time_status = 2; // 进行中
						} else {
							item.time_status = 3; // 已结束
						}
					})
					this.tableData = res.list
					this.$refs.zjlist.total = res.count
				})
			},
			
			addnew() {
				this.$router.push('/system/question_inves_table_add')
			},
			showdate(row) {
				this.$refs.myroomdate.dialogVisible = true
			},
		}
	}
</script>

<style lang="scss" scoped>
	@import 'list.scss';
</style>